import Raf from "quark-raf";

/**
 * Easing function
 * @param { number }
 * easeOutQuint
 */
const ease = (x) => {
    return 1 - Math.pow(1 - x, 5);
};

export default class ScrollTo {
    /**
     * Scroll to a desired target.
     * @param
     *      { node || string} : The DOM element we want to scroll to 
     *      {object} : { offset {number}, duration {number}, callback: {function}, disableLerp: {boolean} }
     */
    static goTo(target, options = {}) {
        // Flag
        if (ScrollTo.isScrolling) this.cancel();
        ScrollTo.isScrolling = true;

        // Get scroll element
        ScrollTo.$scrollElement =
            window.document.scrollingElement ||
            window.document.body ||
            window.document.documentElement;

        // Get target
        let $target = null;
        if (typeof target === "string") {
            const $targets = document.querySelectorAll(target);
            if (!$targets.length) return;
            $target = $targets[0];
        } else if (typeof target === "object") {
            $target = target;
        }
        if (!$target) return;

        // Get target offset
        const $targetOffsetTop = $target.getBoundingClientRect().top;

        // Get options
        const defaultOptions = {
            offset: 0,
            duration: 2000,
            callback: () => {},
            disableLerp: false,
        };

        // Anime Settings
        ScrollTo.targetOptions = { ...defaultOptions, ...options };
        ScrollTo.startTime = performance.now();
        ScrollTo.from = ScrollTo.$scrollElement.scrollTop;
        ScrollTo.to = $targetOffsetTop + parseInt(ScrollTo.targetOptions.offset, 10);

        // Update
        Raf.add(ScrollTo._update);
    }

    /**
     * Cancel go to animation
     */
    static cancel() {
        Raf.remove(ScrollTo._update)
        ScrollTo.isScrolling = false
    }

    /**
     * Update scroll animation
     */
    static _update() {
        const dateNow = performance.now();
        const elapsed = dateNow - ScrollTo.startTime;
        const progress = Math.min(elapsed / ScrollTo.targetOptions.duration, 1);
        const animatedValue = ScrollTo.targetOptions.disableLerp
            ? ScrollTo.from + progress * ScrollTo.to
            : ScrollTo.from + ease(progress) * ScrollTo.to;

        ScrollTo.$scrollElement.scrollTop = animatedValue;

        // Cancel RAF
        if (progress >= 1) {
            ScrollTo.cancel()
            // Apply callback
            ScrollTo.targetOptions.callback();
        }
    }
}
